// extracted by mini-css-extract-plugin
module.exports = {"hidedSection":"ButtonCollapse_hidedSection__2g8Fn","option":"ButtonCollapse_option__2pt8a"};